export default __webpack_public_path__ + "static/media/language.4069e8f2.svg";